import { Fragment, useState } from 'react';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useCanAssignValidationContext } from 'modals/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/CanAssignValidation.validation.context';
import { FEATURE_SELECTORS_MAP } from 'guards/FeatureGuard.constants';
import { useSelector } from 'react-redux';
import { getShiftBiddingStatus } from 'utils/shiftStatus';
import { IAuditTrailFooterProps } from 'modals/ShiftModal/src/views/DetailView/AuditTrailDetailView/AuditTrail.types';
import { useResponsive } from 'providers/ResponsiveProvider/Responsive';
import { MobileAuditTrailDetailTabViewFooter } from 'modals/ShiftModal/src/views/DetailView/AuditTrailDetailView/MobileAuditTrailDetailTabViewFooter';
import { WebAuditTrailDetailTabViewFooter } from 'modals/ShiftModal/src/views/DetailView/AuditTrailDetailView/WebAuditTrailDetailTabViewFooter';
import { useShiftModalPropsContext } from 'modals/ShiftModal/ShiftModal.props.context';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export function AuditTrailDetailTabViewFooter() {
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  const { hasMarketplace } = getCurrentlySelectedLocation();

  const {
    goToDeleteView,
    goToEditView,
    goToReleaseShiftView,
    goToSendToAgenciesView,
    goToAwardTeamMemberView,
  } = useShiftModalPropsContext();

  const isReadOnly = useSelector(
    FEATURE_SELECTORS_MAP['FEATURE_TYPE_YMCA_READ_ONLY_SECONDARY_USER'],
  );

  const { validateAndExecute } = useCanAssignValidationContext();

  const biddingStatus = order
    ? getShiftBiddingStatus({
        status: order.status.value,
        biddable: order.biddable,
        biddingTimeEndsAt: order.biddingTimeEndsAt,
        awardingTimeStartsAt: order.awardingTimeStartsAt,
        bids: order.bids,
      })
    : null;

  const isBlockShift = !!order?.isBlockShift;
  const [isBlockDeleteConfirmationOpen, setIsBlockDeleteConfirmationOpen] = useState(false);

  const { isMobile } = useResponsive();
  const AuditTrailDetailTabViewFooterComponent = isMobile
    ? MobileAuditTrailDetailTabViewFooter
    : WebAuditTrailDetailTabViewFooter;

  if (!order || isReadOnly || (!hasMarketplace && order.isAway)) return <Fragment />;

  const props: IAuditTrailFooterProps = {
    order,
    goToDeleteView,
    goToEditView,
    goToReleaseShiftView,
    goToSendToAgenciesView,
    goToAwardTeamMemberView,
    validateAndExecute,
    biddingStatus,
    isBlockShift,
    isBlockDeleteConfirmationOpen,
    setIsBlockDeleteConfirmationOpen,
  };

  return <AuditTrailDetailTabViewFooterComponent {...props} />;
}
